import { render, staticRenderFns } from "./TransferConfirm.vue?vue&type=template&id=1ae12dbb&scoped=true"
import script from "./TransferConfirm.vue?vue&type=script&lang=js"
export * from "./TransferConfirm.vue?vue&type=script&lang=js"
import style0 from "./TransferConfirm.vue?vue&type=style&index=0&id=1ae12dbb&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae12dbb",
  null
  
)

export default component.exports